<style lang="scss" scoped>
</style>
<template>
  <div>
    <headerIndex 
      v-on:grid="currentView='grid'"
      v-on:list="currentView='list'"
    ></headerIndex>
    <template v-if="currentView == 'list' && path == '/gas'">
      <gasList></gasList>
    </template>
     <template v-if="currentView == 'grid' && path == '/gas'">
      <gasGrid></gasGrid>
    </template>
  </div>
</template>

<script>
export default {
  components: {
    headerIndex: () => import('@/components/headerIndex/headerIndex.vue'),
    gasList: () => import('./Gas/List.vue'),
    gasGrid: () => import('./Gas/Grid.vue')
  },
  data () {
    return {
      currentView: 'list',
      path: ''
    }
  },
  created () {
    this.path = this.$route.path
  }
}
</script>